// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-153d05fe]{overflow-x:auto}.icon-left[data-v-153d05fe]{margin-right:.8em}.icon-left[data-v-153d05fe],.icon-right[data-v-153d05fe]{display:inline-block;background-color:#4f4f4f;padding:.67em .5em .33em}.icon-right[data-v-153d05fe]{margin-left:.8em}.icon-right.red[data-v-153d05fe]{background-color:#ed1c2f}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
